/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Transcript_Export_Duration_ValueInputs */



/**
* | output |
* | --- |
* | "({duration}sec)" |
*
* @param {Transcript_Export_Duration_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_duration_value = /** @type {((inputs: Transcript_Export_Duration_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Duration_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`(${i?.duration} s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`(${i?.duration}sec)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`(${i?.duration}sec)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`(${i?.duration}сек)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`(${i?.duration}seg)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`（${i?.duration}秒）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`(${i?.duration}秒)`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`(${i?.duration}सेकंड)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`(${i?.duration}seg)`)
	return /** @type {LocalizedString} */ (`(${i?.duration}sec)`)
});